import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';

export const OutsOptions: ITaggingFlowOption[] = [
  {
    displayName: 'No Outs',
    value: 0,
    hotkeyCode: 48,
    hotkeyDisplay: '0',
  },
  {
    displayName: '1 Out',
    value: 1,
    hotkeyCode: 49,
    hotkeyDisplay: '1',
  },
  {
    displayName: '2 Outs',
    value: 2,
    hotkeyCode: 50,
    hotkeyDisplay: '2',
  },
  {
    displayName: '3 Outs',
    value: 3,
    hotkeyCode: 51,
    hotkeyDisplay: '3',
  },
];
